export default "__VITE_ASSET__Bm8q72J5__"